import API from 'services/API';

export function setAutoTopup(data) {
  return API.request({
    method: 'POST',
    url: `/autoTopup`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    data,
  });
}
export function disableAutoTopup() {
  return API.request({
    method: 'DELETE',
    url: `/autoTopup`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}
export function getAutoTopup() {
  return API.request({
    method: 'GET',
    url: `/autoTopup`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}
